<div class="app__container">
    <router-outlet></router-outlet>
    <router-outlet name="sidebar"></router-outlet>
</div>
<app-external-scripts></app-external-scripts>
<app-spinner *ngIf="isLoading" class="spinner"></app-spinner>
